<div class="ng-select-wrapper" [attr.isError]="isError">
  <!-- Rendered outside of the editable search field so that it cannot be erased -->
  @if (selectedCountry; as country) {
    <span class="selected-prefix">
      <img class="selected-flag" [src]="getFlagUrl(country)" alt="">
      <span class="selected-plus">+</span>
    </span>
  }
  <app-custom-select
    [formControl]="countryControl"
    [searchable]="true"
    [clearable]="false"
    [externalSearch]="true"
    [selectFirstOnEnter]="true"
    (searchChange)="onSearch($event)"
    placeholder=""
    notFoundText="No results match..."
    panelMinWidth="300px">
    @for (country of displayedCountries; track country.code) {
      <app-custom-select-option
        class="country-option"
        [value]="country.code"
        [isSelected]="country.code === countryControl.value"
        [optionIcon]="getFlagUrl(country)"
        [displayLabel]="country.name + ' ' + country.dial_code"
        [previewLabel]="country.dial_code.slice(1)">
        {{country.name}} ({{country.dial_code}})
      </app-custom-select-option>
    }
  </app-custom-select>
</div>
